var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "f7a59732602c78435c91c58177507b9edd5c19ae"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["butternutbox-frontend@butternut"] = {
  id: "f7a59732602c78435c91c58177507b9edd5c19ae"
};